module.exports = __webpack_public_path__ + "img/S__90480700.49c1fbd4.jpg";